import { DESIGN_MODE_BLANK_THREAD_ID } from './designModeBlankThread'
import {
  DESIGN_DNA_HTML_ARTIFACT_ID,
  ensureDesignDnaDemoArtifactsRegistered,
} from '@/features/chat/demo/designDnaDemo'
import {
  WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
  ensureWebsiteCrmDemoArtifactsRegistered,
} from '@/features/chat/demo/websiteCrmDemo'

/** @param {string} projectId */
export function getDesignModeThreadForProject(_projectId) {
  return {
    id: DESIGN_MODE_BLANK_THREAD_ID,
    title: 'Design System',
  }
}

/** @param {string} projectId */
export function getDesignModePreviewForProject(projectId) {
  if (projectId === 'nexus-procurement') {
    ensureWebsiteCrmDemoArtifactsRegistered()
    return {
      artifactId: WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
      kind: 'html',
      fileName: 'NexusB2B — Procurement Site.html',
      description: 'HTML App',
    }
  }

  ensureDesignDnaDemoArtifactsRegistered()
  return {
    artifactId: DESIGN_DNA_HTML_ARTIFACT_ID,
    kind: 'html',
    fileName: 'MUI Component Showcase.html',
    description: 'HTML App',
  }
}
